import { SourceData } from '@/components/control/TableSelectBox'

export const REVIEW_ALL: SourceData = { value: '', name: '전체' }
export const REVIEW_REQUEST: SourceData = { value: 'REQUEST', name: '검토 요청' }
export const REVIEW_UNDER: SourceData = { value: 'UNDER', name: '검토 중' }
export const REVIEW_COMPLETE: SourceData = { value: 'COMPLETE', name: '검토 완료' }
export const REVIEW_RECEIPT: SourceData = { value: 'RECEIPT', name: '접수' }
export const REVIEW_CONSULT_COMPLETE: SourceData = { value: 'CONSULT_COMPLETE', name: '상담 완료' }
export const REVIEW_NO_RESPONSE: SourceData = { value: 'NO_RESPONSE', name: '미응답' }

export const REVIEW_LIST: SourceData[] = [ REVIEW_ALL, REVIEW_COMPLETE, REVIEW_REQUEST, REVIEW_UNDER ]

